export const RECENT_MEETING_DAYS = 20;
export const MEETING_PAGE_SIZE = 50;

export function localTodayYmd() {
  const n = new Date();
  return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, '0')}-${String(n.getDate()).padStart(2, '0')}`;
}

export function addCalendarDaysYmd(ymd, days) {
  const [y, m, d] = String(ymd || '').split('-').map(Number);
  if (!y || !m || !d) return '';
  const dt = new Date(y, m - 1, d);
  dt.setDate(dt.getDate() + days);
  return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}-${String(dt.getDate()).padStart(2, '0')}`;
}

export function olderArchiveToYmd(today = localTodayYmd()) {
  return addCalendarDaysYmd(today, -(RECENT_MEETING_DAYS + 1));
}

export function attendanceCounts(participants) {
  const list = Array.isArray(participants) ? participants : [];
  return {
    total: list.length,
    present: list.filter((p) => p.attendance === 'present').length,
    absent: list.filter((p) => p.attendance === 'absent').length,
    pending: list.filter((p) => !p.attendance || p.attendance === 'pending').length,
  };
}

export function unwrapMeetingsResponse(res) {
  const payload = res?.pagination ? res : res?.data;
  const rows = Array.isArray(payload?.data) ? payload.data : Array.isArray(payload) ? payload : [];
  const pagination = payload?.pagination || {
    page: 1,
    limit: rows.length || MEETING_PAGE_SIZE,
    total: rows.length,
    pages: rows.length ? 1 : 0,
  };
  return { rows, pagination };
}

export function buildMeetingListParams({ range, search, archiveFrom, archiveTo, page }) {
  const params = { page: page || 1, limit: MEETING_PAGE_SIZE };
  const q = String(search || '').trim();
  if (q) params.q = q;
  if (range === 'older') {
    params.to = archiveTo || olderArchiveToYmd();
    if (archiveFrom) params.from = archiveFrom;
  }
  return params;
}
